// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608120044/js/" + chunkId + "." + {"44":"0af04199","225":"1c2a3fb2","481":"817df392","486":"1d59c884","770":"4817c714"}[chunkId] + ".0.563663212478085.chunk.js";
};